export const GET_PAGE_ACTION = 'GET_PAGE_ACTION';
export const GET_PAGE_SUCCESS_ACTION = 'GET_PAGE_SUCCESS_ACTION';
export const GET_PAGE_FAILURE_ACTION = 'GET_PAGE_FAILURE_ACTION';
